<div class="popover">
  <div class="sign-image-popover">
    <a [href]="principalImage" target="_blank">
      <img class="image-popover" [src]="principalImage" />
    </a>
  </div>
  <div class="info-popover">
    <div class="row-popover">
      <div class="d-flex">
        <app-sign-svg
          [width]="40"
          [height]="40"
          [sign]="signaling?.trafficSigns?.length ? signaling?.trafficSigns[index] : signaling"
          [index]="index"
        ></app-sign-svg>
        <div class="d-flex flex-column ml-3" style="width: 200px;">
          <span class="sign-code">{{ signCode }}</span>
          <span class="sign-name multiline-ellipsis">{{ signCode | enumText: 'Signaling' }}</span>
        </div>
      </div>
      <div (click)="openModal()" class="cursor-pointer" style="font-size: 20px">
        <a
          [ngStyle]="{ color: occurrenceHref ? '--orange-base' : '--gray-base' }"
          [href]="occurrenceHref"
          class="fa-regular fa-message-exclamation fa-lg"
          style="text-decoration: none; pointer-events: none"
        >
        </a>
      </div>
      `
    </div>

    <div class="row-popover">
      <app-popup-warranty-bar [signaling]="signaling" [index]="index"> </app-popup-warranty-bar>
    </div>

    <div class="row-popover">
      <div>
        <div
          *ngIf="signaling?.locations?.length"
          class="d-flex justify-content-center"
          style="width: 40px; height: 24px; background-color: var(--gray-base); border-radius: 8px"
        >
          <h3 style="color: white">{{ 'A' }}</h3>
        </div>

        <div *ngIf="signaling?.trafficSigns?.length > 1" class="row-popover p-1">
          <div
            *ngFor="let trafficSign of signaling?.trafficSigns; index as IndexTraffic"
            (mouseenter)="onHoverEnter(IndexTraffic)"
          >
            <app-sign-svg
              [width]="32"
              [height]="32"
              [sign]="trafficSign"
              [contrast]="IndexTraffic == index"
            ></app-sign-svg>
          </div>
        </div>
      </div>
      <button
        (click)="openDetails(url)"
        [id]="'duplicated-' + signaling?.id"
        class="btn btn-link detail-sidebar-button align-self-end"
      >
        VER ITEM <i class="fas fa-angle-right ml-2 mr-0" style="font-size: 20px"></i>
      </button>
    </div>
  </div>
</div>
